import { ApiClientAxios, apiFactoryConfig, SetAmlIdentificationRequest } from "@repo/api";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";

export type setPPAmlIdentificationVariables = {
    contractId: string;
    setAmlIdentificationRequest: SetAmlIdentificationRequest;
};

export const useSetPPAmlIdentificationMutation = (
    options?: Partial<UseMutationOptions<void, Error, setPPAmlIdentificationVariables>>,
) => {
    const api = ApiClientAxios.ContractsPpApiFactory(...apiFactoryConfig);
    return useMutation<void, Error, setPPAmlIdentificationVariables>({
        mutationFn: async ({ contractId, setAmlIdentificationRequest }: setPPAmlIdentificationVariables) => {
            await api.setPPAmlIdentificationPut(contractId, setAmlIdentificationRequest);
        },
        ...options,
    });
};
